import { SealsComponent } from './SealsComponent';

export function SealsComponentC(
  props: React.ComponentProps<typeof SealsComponent>,
) {
  return <SealsComponent {...props} />;
}
